export const OPEN_CONVERSATION_HEADERS_CONFIG = {
  conversationStartTime: {
    default: true,
    direction: -1,
  },
  lastConversationTime: {
    default: false,
    direction: 1,
  },
  assignment: {
    default: false,
    direction: 1,
  },
  contact: {
    default: false,
    direction: 1,
  },
};

export const CLOSE_CONVERSATION_HEADERS_CONFIG = {
  timeOpen: {
    default: true,
    direction: -1,
  },
  closedTime: {
    default: false,
    direction: 1,
  },
  closedBy: {
    default: false,
    direction: 1,
  },
  closedContact: {
    default: false,
    direction: 1,
  },
};

export const MEDICAID_CONVERSATION_HEADERS_CONFIG = {
  timestamp: {
    default: true,
    direction: -1,
  },
  member: {
    default: false,
    direction: 1,
  },
  medicaidContact: {
    default: false,
    direction: 1,
  },
  messageSentTo: {
    default: false,
    direction: 1,
  },
};

export const CAMPAIGNS_CONVERSATION_HEADERS_CONFIG = {
  timestamp: {
    default: true,
    direction: -1,
  },
  member: {
    default: false,
    direction: 1,
  },
  message: {
    default: false,
    direction: 1,
  },
  contactCount: {
    default: false,
    direction: 1,
  },
  failed: {
    default: false,
    direction: 1,
  },
  contactListName: {
    default: false,
    direction: 1,
  },
};

export const NAVIGATION_TABS = {
  open: 1,
  closed: 2,
  campaigns: 3,
  medicaid: 4,
};

export const FORMS_MANAGER_HEADERS_CONFIG = {
  createdAt: {
    default: true,
    direction: -1,
  },
  title: {
    default: false,
    direction: 1,
  },
  status: {
    default: false,
    direction: 1,
  },
  contact: {
    default: false,
    direction: 1,
  },
};
